<template>
	<div ref="modal" class="modal-column">
		<div class="flex-1 p-16px pr-50px" style="overflow-y: auto;position: relative">
			<Form :readonly="used" ref="form" :labelWidth="150" :model="form" :rules="validationRules" mode="block">
				<img v-if="used" class="used" src="@/assets/used.png" alt="已使用">
				<template v-if="faster">
          <FormItem label="上级科目" prop="parentId" required>
            <Select :deletable="false" :datas="subjectList" keyName="id" titleName="name" filterable type="object"
                    v-model="parentSubject" :filter="filter">
              <template v-slot:item="{ item }">
                {{ item.code }} {{ item.name }}
              </template>
            </Select>
          </FormItem>
          <FormItem label="科目类型" required prop="type">
            <Select :disabled="!!parentSubject" :datas="subjectType" keyName="title" v-model="form.type"
                    :deletable="false"/>
          </FormItem>
        </template>
				<FormItem label="科目编码" prop="code">
					<div class=" sub-code" v-if="!form.id && (parent || parentSubject)">
						<span class="sub-code-pre">{{ (parent || parentSubject).code }}</span>
						<Input type="text" :style="{paddingLeft:(parent || parentSubject).code.length*8+'px'} " v-model="form.code" :maxlength="len"/>
					</div>
					<Input v-else-if="!form.id && !parent" type="text" v-model="form.code" :maxlength="len"/>
					<Input v-else type="text" v-model="form.code" disabled/>
					<div class="pt-5px text-12px">*注意：科目编码规则： {{ encoding.join("-") }}。</div>
				</FormItem>
				<FormItem label="科目名称" prop="name">
					<Input type="text" v-model="form.name" :disabled="form.systemDefault && form.level == 1"/>
				</FormItem>
				<FormItem label="上级科目" v-if="!faster">
					<Input type="text" :value="parent?parent.name:''" disabled/>
				</FormItem>
				<FormItem label="余额方向">
					<Radio v-model="form.balanceDirection" :datas="['借','贷']" :disabled="used || form.systemDefault"/>
				</FormItem>
				<FormItem label="状态">
					<Radio v-model="form.status" dict="statusRadios"></Radio>
				</FormItem>
				<FormItem single :showLabel="false" v-if="User.role != 'ManagerLow' && User.role != 'MakingLow' && User.role != 'ViewLow'">
					<div class="flex">
						<div class="w-80px mr-16px">
							<Checkbox v-model="numberAccounting" :disabled="disabledUni">数量核算</Checkbox>
						</div>
						<div v-if="numberAccounting" class="flex flex-1 items-center">
							<span class="mr-8px">计量单位</span> <Input type="text" v-model="unit" :disabled="disabledUni" class="!w-80px"/>
						</div>
					</div>
				</FormItem>
				<FormItem single :showLabel="false" v-if="User.role != 'ManagerLow' && User.role != 'MakingLow' && User.role != 'ViewLow'">
					<div class="flex">
						<div class="w-80px mr-16px">
							<Checkbox v-model="assistAccounting" :disabled="disabledAccounting">辅助核算</Checkbox>
						</div>
						<div v-if="assistAccounting" class="flex-1">
							<Checkbox :limit="5" v-model="auxiliaryAccounting" :datas="accountingCategory" keyName="id" titleName="name" :disabled="disabledAccounting"></Checkbox>
						</div>
					</div>
				</FormItem>
				<FormItem single :showLabel="false" v-if="currencyList.length>1 && (User.role != 'ManagerLow' && User.role != 'MakingLow' && User.role != 'ViewLow')">
					<div class="flex">
						<div class="w-80px mr-16px">
							<Checkbox v-model="assistCurrencyAccounting" :disabled="disabledCurrencyAccounting" @change="currencyChange">外币核算</Checkbox>
						</div>
						<div v-if="assistCurrencyAccounting" class="flex-1">
							<!--:limit="1"   jxd，限制一个科目只能核算一种外币  -->
							<Checkbox v-model="currencyAccounting" :limit="1" :datas="currencyList.filter(c=>!c.localCurrency)" keyName="id" titleName="name" :disabled="disabledCurrencyAccounting"></Checkbox>
						</div>
					</div>
				</FormItem>
			</Form>
		</div>
		<div class="modal-column-between">
			<Button @click.stop="$emit('close')">取消</Button>
			<div>
				<Button v-if="!form.id " @click="submit(true)" :loading="loading">保存并新增</Button>
				<Button color="green" @click.stop="submit()" :loading="loading">{{ form.id ? '更新' : '保存' }}</Button>
			</div>
		</div>
	</div>
</template>

<script>
import {mapState} from "vuex";
import {clone, padStart} from "xe-utils";
import Setting from "@/api/setting";
import setting from "@/api/setting";
import {confirm} from "heyui.ext";
import EventBus from "@/js/common/EventBus";
import {ArrToObj} from "@js/common/utils";

/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2019-2020金华企客观网络科技有限公司All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2020年08月08日</li>
 * <li>@author     : ____′↘企万慧</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
export default {
	name: "SubjectForm",
	props: {
		type: {
			type: String,
			default: '资产'
		},
		maxCode: String,
		subject: Object,
		parent: Object,
		used: Boolean,
		faster: Boolean,
		fasterUsed:Boolean,// xxxx
	},
	data() {
		return {
			fasterUsedNew : false,// xxxx下
			parentUsed: false,
			subjectList: [],
			currencyList: [],
			encoding: [],
			accountingCategory: [],
			auxiliaryAccounting: [],
			currencyAccounting: [],
			unit: '',
			validationRules: {
				required: ["code", "name", 'type']
			},
			encodingSettingForm: false,
			parentSubject: null,
			numberAccounting: false,
			assistCurrencyAccounting: false,
			assistAccounting: false,
			form: {
        "id": "",
        "code": "",
        "name": "",
        "mnemonicCode": "",
        "unit": "",
        "balanceDirection": "借",
        "auxiliaryAccounting": null,
        "currencyAccounting": null,
        "level": 1,
        "parentId": null,
        "systemDefault": false,
        "type": this.type,
        "status": true
      },
			loading: false
		}
	},
	watch: {
		parentSubject(val) {
			this.setParent(val)
			setting.subject.checkUse(val.id).then(({data}) => {
				console.log("fasterUsedNew",data)
				this.fasterUsedNew = data;
			});
		},
		auxiliaryAccounting(val) {
			let map = val.map(val => this.accountingCategoryMap[val]);
			if (map.find(val => val.categoryType === "VENDOR")) {
				this.accountingCategory.find(val => val.categoryType === "CUSTOMER").disabled = true;
			} else if (map.find(val => val.categoryType === "CUSTOMER")) {
				this.accountingCategory.find(val => val.categoryType === "VENDOR").disabled = true;
			} else {
				const customer = this.accountingCategory.find(val => val.categoryType === "CUSTOMER");
				const vendor = this.accountingCategory.find(val => val.categoryType === "VENDOR");
				if (customer) {
					customer.disabled = false;
				}
				if (vendor) {
					vendor.disabled = false;
				}
			}
		},
		assistAccounting(val) {
			if (!val) {
				this.auxiliaryAccounting = []
			}
		},
		numberAccounting(val) {
			if (!val) {
				this.unit = "";
			}
		}
	},
	computed: {
		...mapState(['currentAccountSets', 'subjectType','User']),
		accountingCategoryMap() {
			return ArrToObj(this.accountingCategory, val => val.id);
		},
		// xxxx下
		disabledUni() {
			console.log(this.fasterUsed)
			//新增的时候，父科目是用过的，且这是新增第一个子科目，禁止编辑核算 数量 外币
			if (this.fasterUsed && this.parent.children.length == 0){
				console.log("shenm")
				return true;
			}else if(this.fasterUsedNew && this.parentSubject.children.length == 0){
				return true;
			}

			if(this.parentSubject){
				return this.used || ((this.parentSubject && this.parentSubject.unit)
				|| (this.parentSubject && this.parentSubject.auxiliaryAccounting && this.parentSubject.auxiliaryAccounting.length)
				|| this.assistCurrencyAccounting)
			}
			return this.used || ((this.parent && this.parent.unit)
				|| (this.parent && this.parent.auxiliaryAccounting && this.parent.auxiliaryAccounting.length)
				|| this.assistCurrencyAccounting)
		},
		disabledAccounting() {
			// console.log(this.fasterUsed,this.parent.children.length)
			//新增的时候，父科目是用过的，且这是新增第一个子科目，禁止编辑核算 数量 外币
			if (this.fasterUsed && this.parent.children.length == 0){
				return true;
			}else if(this.fasterUsedNew && this.parentSubject.children.length == 0){
				return true;
			}

			if(this.parentSubject){
				return this.used || ((this.parentSubject && this.parentSubject.unit)
				|| (this.parentSubject && this.parentSubject.auxiliaryAccounting && this.parentSubject.auxiliaryAccounting.length)
			    || this.assistCurrencyAccounting)
			}
			//jxd嗯有这么几种情况，编辑的时候很简单，如果科目使用过，禁止编辑就行了，新增的时候1.父级科目有三种核算的情况下，第一个子科目肯定要继承父科目的这些核算，所以就禁止编辑这三项，直接继承父级
			//然后这样在后面父级科目就没有任何核算的信息了，这就是第二种情况，父级科目没有任何核算，新增下级科目的时候，就可以直接任意设置了
			return this.used || ((this.parent && this.parent.unit)
				|| (this.parent && this.parent.auxiliaryAccounting && this.parent.auxiliaryAccounting.length)
			    || this.assistCurrencyAccounting)
		},
		disabledCurrencyAccounting() {
			// console.log(this.fasterUsedNew,this.parentSubject)
			//新增的时候，父科目是用过的，且这是新增第一个子科目，禁止编辑核算 数量 外币
			if (this.fasterUsed && this.parent.children.length == 0){
				return true;
			}else if(this.fasterUsedNew && this.parentSubject.children.length == 0){
				return true;
			}

			if(this.parentSubject){
				return this.used || (
				 (this.parentSubject && this.parentSubject.currencyAccounting && this.parentSubject.currencyAccounting.length)
				|| this.assistAccounting || this.numberAccounting)
			}
			// 科目如果已经使用，则直接禁止勾选外币jxd && this.parent.currencyAccounting.length) || this.assistAccounting || this.numberAccounting;
			return this.used || (
				 (this.parent && this.parent.currencyAccounting && this.parent.currencyAccounting.length)
				|| this.assistAccounting || this.numberAccounting)
		}
		// xxxx上
	},
	methods: {
		currencyChange(val) {
			console.log("val",val)
		},
		setParent(val,code) {
			if (val) {
				this.form.parentId = val.id;
				this.form.unit = val.unit;
				this.form.type = val.type;
				this.form.auxiliaryAccounting = val.auxiliaryAccounting;
				this.numberAccounting = !!this.form.unit;
				this.auxiliaryAccounting = val.auxiliaryAccounting;//增加选项值
				this.assistAccounting = this.form.auxiliaryAccounting && this.form.auxiliaryAccounting.length > 0;
				this.assistCurrencyAccounting = this.form.currencyAccounting && assistCurrencyAccounting.length > 0;

				this.unit = this.form.unit;

				this.form.balanceDirection = val.balanceDirection;
				const children = this.subjectList.filter(row => row.parentId === val.id);
				val.children = children;//xxx
				children.sort((a, b) => a.code - b.code);
				
				this.form.code = this.getLastCode(val, children);
				this.form.level = val.level + 1;

				setting.subject.checkUse(val.id).then(({data}) => {
					this.parentUsed = data;
				});
			} else {
				this.parentUsed = false;
				// this.form.parentId = null;//保存新增下，这里如果是null，就永远是1级科目了
				// this.form.level = 1; //保存新增下，这里如果是1，就永远是1级科目了
				this.form.unit = null;
				this.form.auxiliaryAccounting = null;
				this.form.currencyAccounting = null;
				//jxd计算下一个科目编码，保存并新增
				this.form.code = (parseInt(code, 10) + 1).toString().padStart(code.length, '0');
				// this.form.type = '资产';//保存新增下
				// this.form.balanceDirection = '借';//保存新增下
				this.numberAccounting = false;
				this.assistAccounting = false;
			}
      this.$refs.form.valid();
		},
		loadAccountingCategory() {
			return new Promise((resolve) => {
				setting.accountingCategory.list().then(({data}) => {
					data.forEach(val => val.disabled = false)
					this.accountingCategory = data;
					resolve()
				});
				Setting.currency.list().then(({data}) => {
					this.currencyList = data;
				})
			})
		},
		async submit(next = false) {
			let validResult = this.$refs.form.valid();
			if (validResult.result) {
				let formData = clone(this.form, true);
				// console.log(Number(formData.code))
				if(!this.subject && (formData.code.length != this.len || !/^[0-9]+$/.test(formData.code))){
					//科目编码长度不对jxd或不是纯数字
					this.$Message({
							type: 'error',
							text: `科目编码不正确，请查证后重新录入！`
						});
					return;
				}
				if (!(this.assistAccounting && this.auxiliaryAccounting.length)) {
					formData.auxiliaryAccounting = [];
				} else {
					formData.auxiliaryAccounting = this.auxiliaryAccounting;
				}

				if (!(this.assistCurrencyAccounting && this.currencyAccounting.length)) {
					formData.currencyAccounting = [];
				} else {
					formData.currencyAccounting = this.currencyAccounting;
				}

				if (this.numberAccounting && this.unit) {
					formData.unit = this.unit;
				} else {
					formData.unit = "";
				}

				if (this.parent && !formData.id) {
					formData.code = this.parent.code + formData.code;
				}

				if (this.parentSubject) {
					formData.code = this.parentSubject.code + formData.code;
				}

				if (this.parent) {
					//父科目使用过，且父科目新增的是第一个子科目 我们用this.parent.leaf来判断是不是第一个子科目，如果父科目已经有子科目那么this.parent.leaf肯定是false
					const {data} = await setting.subject.checkUse(this.parent.id)
					if (data && this.parent.leaf) {
						const result = await new Promise((resolve) => {
							confirm({
								content: `上级科目已有数据，保存后，<br/>将同时新增同名下级科目${formData.code}${this.parent.name}替代，<br/>您确定要继续吗？`,
								onConfirm() {
									resolve(true)
								},
								onCancel() {
									resolve(false)
								}
							})
						})
						if (!result) {
							return
						}
					}
				}

				this.loading = true;
				setting.subject[formData.id ? 'update' : 'save'](formData).then(() => {
					EventBus.emit('reloadSubject')
					if (next) {
						this.form.name = null;
						this.form.unit = null;
						this.form.parentId = formData.parentId;//保存新增下
						this.form.type = formData.type;//保存新增下
						this.form.balanceDirection = formData.balanceDirection;//保存新增下
						this.form.level = formData.level;//保存新增下
						this.form.auxiliaryAccounting = null;
						this.form.currencyAccounting = null;
						this.numberAccounting = false;
						this.assistAccounting = false;
						this.loadSubject(() => {
							this.setParent(this.parentSubject,this.form.code)//code用于连续计算下一个科目编码
						})
						// jxd 保存新增提示成功
						this.$Message({
							type: 'success',
							text: `${formData.name}新增成功！`
						});
                                                                                                //+
						if (this.parent) {
						this.parent.leaf = false;
						};
					} else {
						this.$emit('success', formData.code);
					}
				}).finally(() => {
					this.loading = false;
				})
			}
		},
		getLastCode(parent, children = []) {
			const reg = new RegExp(this.encoding.map(val => '(\\d{' + val + '})?').join(""))
			this.len = this.encoding[parent.level];
			if (children.length) {
				return reg.exec(String(Number(children[children.length - 1].code) + 1))[parent.level + 1];
			} else {
				return padStart("1", this.len, "0");
			}
		},
		filter(item, val) {
			return item.code.indexOf(val) !== -1 || item.name.indexOf(val) !== -1 || item.mnemonicCode.indexOf(val) !== -1;
		},
		loadSubject(cal) {
			setting.subject.voucherSelect({showAll: 1}).then(({data}) => {
				//过滤掉限定性，非限定性，这个科目不能编辑新增等
				data = data.filter(val => val.code !== '3101' && val.code !== '3102');
				this.subjectList = data;
				console.log(data,"有什么")
				if (cal) {
					cal.call(this)
				}
			});
		}
	},
	created() {
		this.encoding = this.currentAccountSets.encoding;
		this.len = this.encoding[0];
		this.lastCode = this.maxCode ? String(Number(this.maxCode) + 1) : null;
		if (this.parent) {
			this.lastCode = this.getLastCode(this.parent, this.parent.children);

			this.form.parentId = this.parent.id;
			this.form.level = this.parent.level + 1;
			this.form.balanceDirection = this.parent.balanceDirection;
		}
		
		this.loadAccountingCategory().finally(() => {
			//新增的
			if (this.parent) {
				this.form.auxiliaryAccounting = this.auxiliaryAccounting = this.parent.auxiliaryAccounting;
				this.form.currencyAccounting = this.currencyAccounting = this.parent.currencyAccounting;
				this.form.unit = this.unit = this.parent.unit;

				if (this.form.unit) {
					this.numberAccounting = true;
				}

				if (this.form.unit) {
					this.numberAccounting = true;
				}

				if (this.form.auxiliaryAccounting && this.form.auxiliaryAccounting.length > 0) {
					this.assistAccounting = true;
				}
				//jxd
				if (this.form.currencyAccounting && this.form.currencyAccounting.length > 0) {
					this.assistCurrencyAccounting = true;
				}
			}
			//编辑的
			if (this.subject) {
				Object.keys(this.form).forEach(key => {
					this.form[key] = this.subject[key];
				})
				this.numberAccounting = !!this.subject.unit;
				this.assistAccounting = this.subject.auxiliaryAccounting.length > 0;
				this.assistCurrencyAccounting = this.subject.currencyAccounting.length > 0;
				this.unit = this.subject.unit;
				if (this.subject.auxiliaryAccounting) {
					this.auxiliaryAccounting = this.subject.auxiliaryAccounting;
				}
				if (this.subject.currencyAccounting) {
					this.currencyAccounting = this.subject.currencyAccounting;
				}
			} else {
				this.form.code = this.lastCode;
			}
		})

		if (this.faster) {
			this.loadSubject();
		}
	}
}
</script>
<style lang="less">
.used {
  position: absolute;
  right: 50px;
  z-index: 10;
  top: 0;
}
</style>
